/** «Пришли сегодня» для ОО-дашборда (24.08, владелец; переделка 26.08): в счёт
 *  и сумму идут ТОЛЬКО реальные брони (type='booking', не отменённые) — лиды и
 *  отмены видны в списке, но не в цифрах («никакого мусора»). Порядок: брони →
 *  лиды → отменённые. Плюс допработы, админы залов и действия ДК за день
 *  (отмены/переносы) из audit_log. */
import type { OoCreated, OoExtraWorkRow, OoHallAdminRow, OoDcAction } from "./ooDayExtras";

export interface OoDayBrief {
  total: number;
  revenue: number;
  rows: OoCreated[];
  extrawork: OoExtraWorkRow[];
  halladmins: OoHallAdminRow[];
  dcactions: OoDcAction[];
}

const rank = (b: OoCreated) => (b.status === "cancelled" ? 2 : b.type === "lead" ? 1 : 0);

export function buildDayBrief(created: OoCreated[], extrawork: OoExtraWorkRow[], halladmins: OoHallAdminRow[] = [], dcactions: OoDcAction[] = []): OoDayBrief {
  const rows = [...created].sort((a, b) => rank(a) - rank(b));
  const brief: OoDayBrief = { total: 0, revenue: 0, rows, extrawork, halladmins, dcactions };
  for (const b of created) {
    if (b.status === "cancelled" || b.type !== "booking") continue;
    brief.total += 1;
    brief.revenue += b.sum;
  }
  return brief;
}
